
// Import the functions you need from the SDKs you need
import { getAuth } from "firebase/auth";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDlm-PM16r4AqUKvA15PvsMQHPy0fRhOy0",
  authDomain: "schoolgame-97844.firebaseapp.com",
  projectId: "schoolgame-97844",
  storageBucket: "schoolgame-97844.firebasestorage.app",
  messagingSenderId: "543752101738",
  appId: "1:543752101738:web:310ba892aa258846cc4f13"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);